"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SectionColorCircle_1 = __importDefault(require("./SectionColorCircle"));
var SectionTextRaw = function (_a) {
    var title = _a.title, color = _a.color;
    return (react_1.default.createElement("div", { style: { display: "flex", gap: "0.7em", alignItems: "center" } },
        react_1.default.createElement(SectionColorCircle_1.default, { hex: color }),
        react_1.default.createElement("span", { style: { flex: 1 } }, title)));
};
exports.default = SectionTextRaw;
